export default "__VITE_ASSET__DDH4paf9__"